import { flattenObject } from '../../../libs/utils/helpers';

const formatTableSort = (sort: string | null) => {
  const parsedSort = JSON.parse(sort || JSON.stringify({ createdAt: 'DESC' }));

  return flattenObject(parsedSort);
};

export default formatTableSort;
